export default "/img/BT.ded3b20f2e6864e529ec8808ca580b51.png";